export var StampType;
(function (StampType) {
    StampType["TREE_PINE"] = "tree_pine";
    StampType["TREE_OAK"] = "tree_oak";
    StampType["TREE_OAK_LARGE"] = "tree_oak_large";
    StampType["ROCK_SMALL"] = "rock_small";
    StampType["ROCK_MEDIUM"] = "rock_medium";
    StampType["ROCK_LARGE"] = "rock_large";
    StampType["BUILDING_SMALL"] = "building_small";
    StampType["BUILDING_HUT"] = "building_hut";
    StampType["BUILDING_TOWER"] = "building_tower";
    StampType["TORCH"] = "torch";
})(StampType || (StampType = {}));
/**
 * Calculate bounding box from voxels
 */
export function calculateBounds(voxels) {
    if (voxels.length === 0) {
        return { minX: 0, maxX: 0, minY: 0, maxY: 0, minZ: 0, maxZ: 0 };
    }
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;
    let minZ = Infinity, maxZ = -Infinity;
    for (const v of voxels) {
        minX = Math.min(minX, v.x);
        maxX = Math.max(maxX, v.x);
        minY = Math.min(minY, v.y);
        maxY = Math.max(maxY, v.y);
        minZ = Math.min(minZ, v.z);
        maxZ = Math.max(maxZ, v.z);
    }
    return { minX, maxX, minY, maxY, minZ, maxZ };
}
//# sourceMappingURL=StampTypes.js.map